export default __webpack_public_path__ + "static/media/kitchen5-beforeE-1920w.50b678f9.webp";